const MONITORING_SCOPES = ["personal", "spaces", "both"] as const;
export type MonitoringScope = (typeof MONITORING_SCOPES)[number];

// Under "both", every personal space folds into one aggregate segment so the
// combined view stays uncluttered and doesn't surface each member's personal
// usage by name; "personal" breaks them back out individually. Panels key that
// aggregate segment by this id.
export const PERSONAL_BUCKET = "__personal__";

// Gray reads as "other/aggregate", matching the palette's reserved slot.
export const PERSONAL_BUCKET_COLOR = "var(--gray-600)";

export function foldsPersonal(scope: MonitoringScope): boolean {
  return scope === "both";
}

export function scopeFromParam(value: string | undefined): MonitoringScope {
  return value === "personal" || value === "spaces" ? value : "both";
}

// null spaceId is tenant-wide/unattributed usage, which belongs to neither space
// mode and so only surfaces under the inclusive "both".
export function matchesScope(
  scope: MonitoringScope,
  spaceId: string | null | undefined,
  personalIds: ReadonlySet<string>,
  teamIds: ReadonlySet<string>
): boolean {
  if (scope === "both") return true;
  if (spaceId == null) return false;
  return scope === "personal" ? personalIds.has(spaceId) : teamIds.has(spaceId);
}
